module.exports = __webpack_public_path__ + "static/media/available-building.0218e403.svg";